module.exports = __webpack_public_path__ + "img/sportsbook.b2cbaedb.png";